import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import createDynamicLink from "../component/firebase";

function ShareView() {
  const { compaign_id } = useParams();
  const baseUrl = window.location.origin; // Returns the base URL

  const [uniqueToken, setUniqueToken] = useState(
    localStorage.getItem("shared_token")
  );
  const [dynamicLink, setDynamicLink] = useState(
    localStorage.getItem("dynamic_link")
  );

  useEffect(() => {
    const initialize = async () => {
      let token = localStorage.getItem("shared_token");
      if (!token) {
        token = generateUUID(); // Generate a unique token
        localStorage.setItem("shared_token", token);
        setUniqueToken(token);

        // Create dynamic link
        try {
          // Make the API call
          await axios
            .get(
              `${process.env.REACT_APP_API_URL}/compaign_process?type=click&token=${token}&compaign_id=${compaign_id}`
            )
            .then((response) => {
              console.log("TARIQ ", response.data);
            });
        } catch (error) {
          alert(error.message);
          console.error("Error during initialization:", error);
        }
      }
    };

    initialize();
  }, [compaign_id]);

  function generateUUID() {
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID();
    } else {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
        const r = (crypto.getRandomValues(new Uint8Array(1))[0] & 0xf) | 0x8;
        return char === "x" ? r.toString(16) : ((r & 0x3) | 0x8).toString(16);
      });
    }
  }

  const generateDeepLink = async () => {
    const input_url = `${baseUrl}/share/${compaign_id}`;
    if (!dynamicLink) {
      const newLink = await createDynamicLink(input_url, "");
      localStorage.setItem("dynamic_link", newLink);
      console.log("TARIQ ", { input_url, newLink, uniqueToken });
      setDynamicLink(newLink);
      window.location.href = newLink;
    } else {
      window.location.href = dynamicLink;
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <button onClick={generateDeepLink} className="btn btn-success">
        Download App
      </button>
    </div>
  );
}

export default ShareView;
